<template>
    <b-container>
        <template v-if="notes.length">
            <div class="note-card animated fadeIn bg-white p-2 mb-1" v-for="note in notes" :key="note.uuid">

                <div class="font-weight-light">
                    <div class="float-right">{{ note.date | dateFormat('DD/MM/YYYY HH:mm') }}</div>
                    <div>{{ note.user }}</div>
                </div>
                <hr class="mt-1">
                <div>{{ note.note }}</div>

            </div>
        </template>
        <template v-else>
            <div class="py-2 text-center">No hay notas</div>
        </template>
    </b-container>
</template>

<script>
    export default {
        name: "client-note-list",
        props: {
            notes: {
                type: Array,
                required: true,
                default: function () {
                    return [];
                }
            }
        }
    }
</script>

<style scoped>
    .note-card {
    }
</style>